// extracted by mini-css-extract-plugin
export default {"field":"Select_field__yW-y+","isBig":"Select_isBig__Q3A+L","react-select-2-listbox":"Select_react-select-2-listbox__sqsXT"};